import { DpFanRecommendedContent } from '@/components/blocks/DpFanRecommendedContent';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { usePostLoginDialog } from '@/data/context/postLoginDialog';

export const DpFanPostLoginDialog = () => {
	const { active } = usePostLoginDialog();
	const router = useNextRouter();

	if (router.asPath.includes('quiz-dpfan')) return null;
	if (!active) return null;

	return <DpFanRecommendedContent emsName="DPV2DpFanDialog" />;
};
